import React from 'react';
import { motion } from 'framer-motion';
import { GoldButton } from './ui/GoldButton';
import { ShieldCheck } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="w-full bg-[#1B2141] py-24 px-6 md:px-8 text-[#FAF6F0]" data-id="element-147">
      <div className="max-w-4xl mx-auto text-center" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#1B2141] border border-[#C9A96E]/30 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-149">
          {/* Decorative glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[#C9A96E]/5 pointer-events-none" data-id="element-150"></div>

          <h2 className="font-serif text-3xl md:text-5xl mb-4 relative z-10" data-id="element-151">
            El Club de las 3:00 AM
          </h2>
          <p className="text-xl text-[#C9A96E] mb-8 relative z-10" data-id="element-152">
            PDF + Imprimibles + Plan Guiado
          </p>

          <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="relative z-10 mb-4 inline-block" data-id="element-153">
            <span className="bg-[#C9A96E] text-[#1B2141] font-bold text-lg md:text-xl px-5 py-2 rounded-full tracking-wide shadow-lg" data-id="element-154">
              🔥 68% OFF — Oferta Limitada
            </span>
          </motion.div>

          <div className="relative z-10 mb-8 mt-4" data-id="element-155">
            <span className="text-2xl md:text-3xl font-serif text-[#FAF6F0]/40 line-through mr-4" data-id="element-156">
              $19
            </span>
            <span className="text-6xl md:text-7xl font-serif font-bold text-[#C9A96E]" data-id="element-157">
              $6.39
            </span>
            <p className="text-[#FAF6F0]/50 text-sm mt-2" data-id="element-158">Ahorras $12.61 hoy</p>
          </div>

          <div className="flex justify-center mb-10 relative z-10" data-id="element-159">
            <GoldButton className="w-full md:w-auto min-w-[300px] text-xl py-5" data-id="element-160">
              Descargar Ahora
            </GoldButton>
          </div>

          <div className="flex items-center justify-center gap-2 text-[#FAF6F0]/60 text-sm mb-12 relative z-10" data-id="element-161">
            <ShieldCheck className="w-4 h-4" data-id="element-162" />
            <span data-id="element-163">Pago seguro · Acceso inmediato</span>
          </div>

          <div className="border-t border-[#FAF6F0]/10 pt-10 max-w-2xl mx-auto relative z-10" data-id="element-164">
            <p className="text-lg md:text-xl leading-relaxed text-[#FAF6F0]/90" data-id="element-165">
              Esta noche puede ser otra repetición… o puede ser la primera noche
              en la que, cuando abras los ojos, no entres en pánico.
            </p>
            <p className="mt-6 font-serif text-2xl italic text-[#C9A96E]" data-id="element-166">
              No necesitas una rutina perfecta. Necesitas un camino.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}